import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(values: any [], args?: string): any {
    if (!values) { return []; };
    if (!args) {return values; };

    args = args.toLowerCase();
    return values.filter((item) => item.name.toLowerCase().includes(args));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/search-dropdown/filter.pipe.ts